import { DemoSection } from '@/components/demo-section'
import { Footer } from '@/components/footer'
import { useParams } from 'react-router-dom'

export function DemoPage() {
  const { gameId } = useParams<{ gameId: string }>()

  return (
    <div className="min-h-screen bg-background text-foreground">
      <main>
        <section id="demo">
          <DemoSection initialGameId={gameId} />
        </section>
      </main>
      <Footer />
    </div>
  )
}
